import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import * as Select from "@radix-ui/react-select";
import { ListItem, Box, AHText } from "arkh";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { OrgSelector } from "../../OrgHome/OrgSelector/Selector";
import { RoutineEditMainOrgTopicListItem_topics$key } from "./__generated__/RoutineEditMainOrgTopicListItem_topics.graphql";
import { useMemo } from "react";
import { View } from "react-native";
import { RoutineEditMainOrgTopicListItemSelector_topics$key } from "./__generated__/RoutineEditMainOrgTopicListItemSelector_topics.graphql";

export function RoutineEditOrgTopicListItem(props: {
  topics: RoutineEditMainOrgTopicListItem_topics$key;
  selectedTopic?: string;
  onSelectedTopicChange?: (topic: string) => void;
  children?: React.ReactNode;
}) {
  const topics = useFragment(
    graphql`
      fragment RoutineEditMainOrgTopicListItem_topics on OrgTopic
      @relay(plural: true) {
        __typename
        ...RoutineEditMainOrgTopicListItemSelector_topics
      }
    `,
    props.topics
  );
  const intl_tokens = useIntlTokens();

  if (topics.length === 0) {
    return null;
  }
  const selectedTopic = props.selectedTopic ?? "NONE";

  return (
    <ListItem
      border="border-primary"
      isFree
      disabled
      right={
        <RoutineEditMainOrgTopicSelector
          topics={topics}
          selectedTopic={selectedTopic}
          onSelectedTopicChange={props.onSelectedTopicChange}
        />
      }
    >
      <ListItem.Title>{intl_tokens.Topic}</ListItem.Title>
      {props.children}
    </ListItem>
  );
}

export function RoutineEditMainOrgTopicSelector(props: {
  topics: RoutineEditMainOrgTopicListItemSelector_topics$key;
  selectedTopic?: string;
  onSelectedTopicChange?: (topic: string) => void;
  children?: React.ReactNode;
}) {
  const topics = useFragment(
    graphql`
      fragment RoutineEditMainOrgTopicListItemSelector_topics on OrgTopic
      @relay(plural: true) {
        id
        name
        description
      }
    `,
    props.topics
  );
  const intl_tokens = useIntlTokens();
  const allTopics = useMemo(() => {
    return [
      { id: "NONE", name: intl_tokens.AllTeams, description: "" },
      ...topics,
    ];
  }, [topics, intl_tokens]);

  if (topics.length === 0) {
    return null;
  }
  const selectedTopic = props.selectedTopic ?? "NONE";

  return (
    <View style={{ minWidth: 120 }}>
      <OrgSelector
        options={allTopics.map((t) => t.id)}
        selectedValue={selectedTopic}
        onValueChange={(v) => {
          props.onSelectedTopicChange?.(v);
        }}
        renderValue={(v) => (
          <Box
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",

              flex: 1,
            }}
          >
            <AHText
              spaceRight="small"
              style={{ flex: 1 }}
              color={"text-primary"}
            >
              {selectedTopic
                ? allTopics.find((t) => t.id === selectedTopic)?.name
                : intl_tokens.AllUnitsAndTeams}
            </AHText>
          </Box>
        )}
        renderOption={(v) => {
          const p = allTopics.find((t) => t.id === v);
          if (!p) {
            return null;
          }
          return (
            <Box style={{ flex: 1 }}>
              <Box
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flex: 1,
                }}
              >
                <Select.ItemText>
                  <AHText color="darkerText" spaceRight="large">
                    {p.name}
                  </AHText>
                </Select.ItemText>
              </Box>
            </Box>
          );
        }}
      />
    </View>
  );
}
